import { ReactNode } from 'react';
import { RefundMode as RefundModeDto, SimpleAmount, Amount as AmountType } from '@mews-commander/data-access';

export enum PaymentRefundFormField {
    Amount = 'amount',
    Notes = 'notes',
    RefundMode = 'refundMode',
}

export enum PaymentRefundWithFXFormField {
    ChargedCurrencyAmount = 'chargedCurrencyAmount',
    PropertyCurrencyAmount = 'propertyCurrencyAmount',
    Notes = 'notes',
    RefundMode = 'refundMode',
}
export interface PaymentRefundNormalizedData {
    refundableValue: number;
    refundConversionMultiplier: number;
    chargeAmount: SimpleAmount;
    propertyCurrencyRefundAmount: SimpleAmount;
    accountingCurrencyToPaymentGatewayAmount: AmountType;
    customerId: string;
    chargeConversionRate: ReactNode | null;
    refundConversionRate: ReactNode | null;
    refundMode: RefundModeDto;
}
